import React from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { AdminPanelSettings } from '@mui/icons-material';

type AppBarExtrasProps = {
  themeMode: 'dark' | 'light';
  setThemeMode: (mode: 'dark' | 'light') => void;
};

type AppBarActionsProps = {
  onOpenAdmin: () => void;
};

export function AppBarExtras({ themeMode, setThemeMode }: AppBarExtrasProps) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <FormControl size="small" variant="outlined" sx={{ minWidth: 140 }}>
        <InputLabel id="theme-select-label">Theme</InputLabel>
        <Select
          labelId="theme-select-label"
          label="Theme"
          value={themeMode}
          onChange={(ev) => setThemeMode(ev.target.value as 'dark' | 'light')}
        >
          <MenuItem value="dark">Dark</MenuItem>
          <MenuItem value="light">Light</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
}

export function AppBarActions({ onOpenAdmin }: AppBarActionsProps) {
  return (
    <Button
      variant="outlined"
      startIcon={<AdminPanelSettings />}
      onClick={onOpenAdmin}
      sx={{ borderColor: '#1f242f', color: 'text.primary' }}
    >
      Administration
    </Button>
  );
}
